'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiRfps = function ApiRfps(Restangular, ApiBaseResponseService) {
    _classCallCheck(this, ApiRfps);

    return {
        /**
         * Get all/active rfps
         * @return {Object}
         */
        getRfps: function getRfps(rfpsFilter) {
            return Restangular.all('requestForProposals').all('filter').post(rfpsFilter).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Get constants
         */
        getConstants: function getConstants() {
            return Restangular.one('requestForProposals').one('constants').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        }
    };
};

ApiRfps.inject = ['Restangular', 'ApiBaseResponseService'];

exports.default = ApiRfps;


/** WEBPACK FOOTER **
 ** ./src/app/services/apiRfps.js
 **/